<section class="team-area ptb-100 pt-0">
    <div class="container">
        <div class="section-title">
            <br/><br/>
            <span class="sub-title">Our Team</span>
            <h2>Meet Our Core Team Members</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-image/raju.jpg" alt="Raju Janagani">
                        <div class="social">
                            <a href="https://www.facebook.com/raju.janagani" target="_blank"><i class="fab fa-facebook-f"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
                            <a href="https://www.linkedin.com/in/raju-janagani-7b14aa14/" target="_blank"><i class="fab fa-linkedin"></i></a>
                        </div>
                    </div>
                    <div class="content">
                        <h3>Raju Janagani</h3>
                        <span>Co Founder</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-image/ravi.jpg" alt="Ravindra Naik">
                        <div class="social">
                            <a href="https://www.linkedin.com/in/naik899/" target="_blank"><i class="fab fa-linkedin"></i></a>
                            <a href="https://twitter.com/ravindranaik899" target="_blank"><i class="fab fa-twitter"></i></a>
                            <a href="http://ravindranaik.com/" target="_blank"><i class="fab fa-wordpress"></i></a>
                        </div>
                    </div>
                    <div class="content">
                        <h3>Ravindra Naik</h3>
                        <span>VP of Product</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-image/vikas.jpeg" style="max-height: 350px;" alt="Vikas Pachori">
                        <div class="social">
                            <a href="https://www.facebook.com/vikas.pachori" target="_blank"><i class="fab fa-facebook-f"></i></a>
                            <a href="https://twitter.com/vikas_pachori" target="_blank"><i class="fab fa-twitter"></i></a>
                            <a href="https://www.linkedin.com/in/vikas-pachori/" target="_blank"><i class="fab fa-linkedin"></i></a>
                        </div>
                    </div>
                    <div class="content">
                        <h3>Vikas Pachori</h3>
                        <span>Architect</span>
                    </div>
                </div>
            </div>

           
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/shape5.png" alt="image"></div>
    <div class="shape-img6"><img src="assets/img/shape/shape6.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/shape9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/shape10.png" alt="image"></div>
</section>